import {
  captureCallsRuntimeEvidence,
  type CallsRuntimeEvidenceRecord,
} from './CallsRuntimeEvidencePipeline';

export type CallsRuntimeControlledAction =
  | 'start'
  | 'answer'
  | 'end';

export type CallsRuntimeControlOutcome =
  | 'authorized'
  | 'denied';

export interface CallsRuntimeControlContext {
  readonly callId?: string;
  readonly callerId?: string;
  readonly receiverId?: string;
  readonly source?: string;
}

export interface CallsRuntimeControlResult {
  readonly action: CallsRuntimeControlledAction;
  readonly outcome: CallsRuntimeControlOutcome;
  readonly allowed: boolean;
  readonly governor: string;
  readonly governorId: string;
  readonly governorKey: string;
  readonly domain: string;
  readonly lifecycle: string;
  readonly evidenceId: string;
  readonly evidenceSource:
    'calls-runtime-control-adapter';
  readonly upstreamEvidenceSource:
    CallsRuntimeEvidenceRecord['evidenceSource'];
  readonly decision:
    CallsRuntimeEvidenceRecord['decision'];
  readonly execution:
    CallsRuntimeEvidenceRecord['execution'];
  readonly reasonCode: string;
  readonly reason: string;
  readonly callId?: string;
  readonly callerId?: string;
  readonly receiverId?: string;
  readonly source?: string;
  readonly controlledAt: string;
}

export function authorizeCallsRuntimeAction(
  action: CallsRuntimeControlledAction,
  context: CallsRuntimeControlContext = {},
): CallsRuntimeControlResult {
  const evidence = captureCallsRuntimeEvidence();
  const allowed = evidence.executionAuthorized === true;

  return Object.freeze({
    action,
    outcome: allowed ? 'authorized' : 'denied',
    allowed,
    governor: evidence.governor,
    governorId: evidence.governorId,
    governorKey: evidence.governorKey,
    domain: evidence.domain,
    lifecycle: evidence.lifecycle,
    evidenceId: evidence.evidenceId,
    evidenceSource: 'calls-runtime-control-adapter',
    upstreamEvidenceSource: evidence.evidenceSource,
    decision: evidence.decision,
    execution: evidence.execution,
    reasonCode: evidence.reasonCode,
    reason: evidence.reason,
    callId: context.callId,
    callerId: context.callerId,
    receiverId: context.receiverId,
    source: context.source,
    controlledAt: new Date().toISOString(),
  });
}
